export default class NextMonthTitle extends HTMLElement {
  constructor() {
    super();

    this.innerText = this.nextMonthTitle;
  }

  get nextMonthTitle() {
    // get current datetime for EST (to sync with when Book Club products turn over)
    const nowESTLocaleString = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
    });
    const nowEST = new Date(nowESTLocaleString);

    const currentMonth = nowEST.getMonth();

    /**
     * When setting month, set day to `28` to avoid setting a date that doesn't exist.
     * Doing so moves date to subsequent month (e.g. setting June 31 becomes July 1).
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/setMonth#description
     */
    nowEST.setMonth(currentMonth + 1, 28);

    return nowEST.toLocaleDateString(undefined, {
      month: "long",
    });
  }
}
